<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex xs12 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>
                <v-toolbar flat dense>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="loadSysLog"
                            >
                                <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                :disabled="!selectedRow"
                                @click="showCurrentMessage"
                            >
                                <v-icon>mdi-eye-outline</v-icon> {{ $t("showMessage") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("showMessage") }}</span>
                    </v-tooltip>
                </v-toolbar>

                <!--
                <v-card-title>
                    <h2>{{ $t("sysLog") }}</h2>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="sysLogSearch"
                        append-icon="search"
                        :label="$t('search')"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                -->

                <v-card-text>
                    <v-container fluid fill-height grid-list-xs pa-0>
                        <v-layout row wrap>
                            <v-flex xs12 md8 lg9 d-flex pa-0 style="overflow-x: auto;" class="v-scrollable">
                                <v-data-table
                                    :rows-per-page-items="rowsPerPageItems"
                                    disable-initial-sort
                                    :headers="computedHeaders"
                                    :items="filteredData"
                                    :search="sysLogSearch"
                                    :custom-sort="customSort"
                                    class="dense-table"
                                >
                                    <template v-slot:items="props">
                                        <tr
                                            @click="selectedRow = props.item"
                                            @dblclick="showCurrentMessage"
                                            :class="{'grey darken-5': props.item === selectedRow}"
                                        >
                                            <td class="text-xs-left">{{ props.item.createdAt }}</td>
                                            <td class="text-xs-left">{{ props.item.IPAddr }}</td>
                                            <td class="text-xs-left">{{ props.item.User }}</td>
                                            <td class="text-xs-left">{{ props.item.Module }}</td>
                                            <td class="text-xs-left">{{ props.item.MessageType }}</td>
                                            <td class="text-xs-left">{{ props.item.Message.length > 70 ? props.item.Message.substring(0, 70).trim() + "..." : props.item.Message }}</td>
                                        </tr>
                                    </template>
                                    <template v-slot:no-results>
                                        <v-alert :value="true" color="error" icon="warning">
                                            {{ $t("youSearchFor") }}{{ sysLogSearch }}{{ $t("foundNoResults") }}.
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            <v-flex xs12 md4 lg3 d-flex py-0 pl-2 class="v-scrollable border-rounded">
                                <v-sheet
                                    class="grey dense border-rounded"
                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                    style="overflow: auto;"
                                >
                                    <v-expansion-panel v-model="filterPanels" expand style="overflow-y: hidden;">
                                        <v-expansion-panel-content
                                            class="grey"
                                            :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                        >
                                            <template v-slot:header>
                                                <div class="subheading font-weight-bold">{{ $t("messageType") }}</div>
                                            </template>
                                            <v-card
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card-text class="dense">
                                                    <v-layout row>
                                                        <v-flex xs12d-flex>
                                                            <template>
                                                                <v-checkbox
                                                                    v-for="(item, index) in typesList"
                                                                    v-model="filters.MessageType"
                                                                    :key="index"
                                                                    :value="item.title"
                                                                    :label="item.title"
                                                                ></v-checkbox>
                                                            </template>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                            <v-divider></v-divider>
                                        </v-expansion-panel-content>

                                        <v-expansion-panel-content
                                            class="grey"
                                            :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                        >
                                            <template v-slot:header>
                                                <div class="subheading font-weight-bold">{{ $t("module") }}</div>
                                            </template>
                                            <v-card
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card-text class="dense">
                                                    <v-layout row>
                                                        <v-flex xs12d-flex>
                                                            <template>
                                                                <v-checkbox
                                                                    v-for="(item, index) in modulesList"
                                                                    v-model="filters.Module"
                                                                    :key="index"
                                                                    :value="item.title"
                                                                    :label="item.title"
                                                                ></v-checkbox>
                                                            </template>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                            <v-divider></v-divider>
                                        </v-expansion-panel-content>

                                        <v-expansion-panel-content
                                            class="grey"
                                            :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                        >
                                            <template v-slot:header>
                                                <div class="subheading font-weight-bold">{{ $t("user") }}</div>
                                            </template>
                                            <v-card
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card-text class="dense">
                                                    <v-layout row>
                                                        <v-flex xs12d-flex>
                                                            <template>
                                                                <v-checkbox
                                                                    v-for="(item, index) in usersList"
                                                                    v-model="filters.User"
                                                                    :key="index"
                                                                    :value="item.title"
                                                                    :label="item.title"
                                                                ></v-checkbox>
                                                            </template>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                            <v-divider></v-divider>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel v-model="filterButtons" class="filterButtons" readonly expand style="overflow-y: hidden;">
                                        <v-expansion-panel-content
                                            class="grey"
                                            :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            hide-actions
                                        >
                                            <v-card
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card-text class="dense">
                                                    <v-layout row>
                                                        <v-flex xs12d-flex>
                                                            <v-btn block color="success" v-if="false">{{ $t("apply") }}</v-btn>
                                                            <v-btn block color="warning" @click="resetFilters">{{ $t("reset") }}</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                            <v-divider></v-divider>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-sheet>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-flex>
        <message-box ref="MessageBox"/>
        <sys-log-dialog ref="SysLogDialog"/>
    </v-layout>
</template>

<script>
    import MessageBox   from "@/components/dialogs/MessageBox";
    import SysLogDialog from "@/components/dialogs/SysLogDialog";

    export default {
        name: "SysLog",

        inject: ["theme"],

        components: {
            MessageBox,
            SysLogDialog
        },

        data () {
            return {
                visible: false,
                breadCrumbs: [
                    { text: "Администрирование", disabled: false },
                    { text: "Системный журнал",  disabled: false }
                ],
                headers: [
                    { text: "id",           value: "id",          align: "center", sortable: true },
                    { text: "Время",        value: "createdAt",   align: "left",   sortable: true },
                    { text: "IP",           value: "IPAddr",      align: "left",   sortable: true },
                    { text: "Пользователь", value: "User",        align: "left",   sortable: true },
                    { text: "Модуль",       value: "Module",      align: "left",   sortable: true },
                    { text: "Тип",          value: "MessageType", align: "left",   sortable: true },
                    { text: "Сообщение",    value: "Message",     align: "left",   sortable: true }
                ],
                hideIDs: true,
                rowsPerPageItems: [25,50,75,95],

                progressBarVisible: false,
                selectedRow: null,
                dialogWatcher: null,

                filterButtons: 0,
                filterPanels: [true, true, false],
                filters: {
                    Module:      [],
                    MessageType: [],
                    User:        []
                },

                modulesList: [],
                typesList:   [],
                usersList:   [],

                sysLog: [],
                sysLogSearch: ""
            }
        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                }

                return this.headers;
            },

            filteredData () {
                return this.sysLog.filter(data => {
                    return Object.keys(this.filters).every(filter => {
                        return this.filters[filter].length < 1 || this.filters[filter].includes(data[filter])
                    })
                })
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            }
        },

        mounted () {
            // user roles: 1 - user, 2 - manager, 3 - admin
            if (!this.$store.getters.user.loggedIn || this.$store.getters.user.role < 3) {
                localStorage.routerPath = "/syslog";
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("administration"), disabled: false },
                    { text: this.$t("sysLog"),         disabled: false }
                ];

                this.headers = [
                    { text: "id",               value: "id",          align: "center", sortable: true },
                    { text: this.$t("time"),    value: "createdAt",   align: "left",   sortable: true },
                    { text: "IP",               value: "IPAddr",      align: "left",   sortable: true },
                    { text: this.$t("user"),    value: "User",        align: "left",   sortable: true },
                    { text: this.$t("module"),  value: "Module",      align: "left",   sortable: true },
                    { text: this.$t("type"),    value: "MessageType", align: "left",   sortable: true },
                    { text: this.$t("message"), value: "Message",     align: "left",   sortable: true }
                ];

                this.loadSysLog();
            },

            /**
             * Сортировка таблицы
             *
             * @param {array}   items  Сортируемый список
             * @param {string}  index  Столбец сортировки
             * @param {boolean} isDesc Флаг сортировки по убыванию
             */
            customSort(items, index, isDesc) {
                items.sort((a, b) => {
                    if (index === "createdAt") {
                        if (!isDesc) {
                            return a.createdTimestamp < b.createdTimestamp ? -1 : 1;
                        } else {
                            return a.createdTimestamp > b.createdTimestamp ? -1 : 1;
                        }
                    } else {
                        if (!isDesc) {
                            return a[index] < b[index] ? -1 : 1;
                        } else {
                            return a[index] > b[index] ? -1 : 1;
                        }
                    }
                });
                return items;
            },

            /**
             * Загрузка системного журнала
             */
            loadSysLog () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}syslog/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let sysLogInfo = response.data.log

                            this.sysLog    = [];

                            sysLogInfo.forEach((item) => {
                                this.sysLog.push({
                                    id:          item.id,
                                    createdAt:   new Date(item.createdAt).toLocaleString(),
                                    createdTimestamp: Date.parse(item.createdAt),
                                    IPAddr:      item.IPAddr,
                                    User:        item.User,
                                    Module:      this.$t(item.Module.Name),
                                    MessageType: this.$t(item.MessageType.Name),
                                    Message:     item.Message
                                });

                                let newUser = true;

                                this.usersList.forEach(element => {
                                    if (element.title == item.User) { newUser = false; }
                                });

                                if (newUser) {
                                    this.usersList.push({
                                        id:    item.id,
                                        title: item.User
                                    });
                                }

                                let newModule = true;

                                this.modulesList.forEach(element => {
                                    if (element.title == this.$t(item.Module.Name)) { newModule = false; }
                                });

                                if (newModule) {
                                    this.modulesList.push({
                                        id:    item.id,
                                        title: this.$t(item.Module.Name)
                                    });
                                }

                                let newMessageType = true;

                                this.typesList.forEach(element => {
                                    if (element.title == this.$t(item.MessageType.Name)) { newMessageType = false; }
                                });

                                if (newMessageType) {
                                    this.typesList.push({
                                        id:    item.id,
                                        title: this.$t(item.MessageType.Name)
                                    });
                                }
                            });

                            this.sysLog.sort((a, b)      => { return a.createdTimestamp > b.createdTimestamp; });
                            this.usersList.sort((a, b)   => { return a.title > b.title; });
                            this.modulesList.sort((a, b) => { return a.title > b.title; });
                            this.typesList.sort((a, b)   => { return a.title > b.title; });
                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSystemLog") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSystemLog") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSystemLog"));
                        }
                    });
            },

            /**
             * Отображение текущего сообщения
             */
            showCurrentMessage () {
                this.$refs.SysLogDialog.time        = this.selectedRow.createdAt;
                this.$refs.SysLogDialog.ip          = this.selectedRow.IPAddr;
                this.$refs.SysLogDialog.moduleName  = this.selectedRow.Module;
                this.$refs.SysLogDialog.type        = this.selectedRow.MessageType;
                this.$refs.SysLogDialog.user        = this.selectedRow.User;
                this.$refs.SysLogDialog.messageText = this.selectedRow.Message;
                this.$refs.SysLogDialog.dialog      = true;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Сброс фильтров
             */
            resetFilters () {
                this.filters.module = [];
                this.filters.type   = [];
                this.filters.user   = [];
            },
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 144px)
</style>
